import React, { useRef, useEffect } from 'react';
import './css/App.css';
import './css/theme.css';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './print.css';
import { addLocale } from 'primereact/api';
import { PrimeReactProvider } from 'primereact/api';
import getSdk, { ApplicationSdk } from './core/sdk';
import { observer } from 'mobx-react-lite';
import AuthView from './auth';
import { PortalView, EmployeeView } from './PortalView';
import DialogView from './DialogView';
import { Toast } from 'primereact/toast';
import { DialogInput } from './core/dialogs';
import { PublicView } from './PublicView';

addLocale('de', {
    firstDayOfWeek: 1,
    dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    dayNamesShort: ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
    dayNamesMin: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
    monthNames: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
    ],
    monthNamesShort: [
        'Jan',
        'Feb',
        'Mär',
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez',
    ],
    today: 'Heute',
    clear: 'Löschen',
});

const App = observer(() => {
    const toast = useRef<Toast>(null);
    const sdk: ApplicationSdk = getSdk();

    const showToast = (toaster: any) => {
        toast.current?.show({
            ...toaster,
            detail: <div style={{ whiteSpace: 'pre-line' }}>{toaster.message}</div>,
        });
    };

    useEffect(() => {
        sdk.registerToastCallback(showToast);
    }, [sdk]);

    return (
        <PrimeReactProvider
            value={{
                hideOverlaysOnDocumentScrolling: false,
                ripple: true,
            }}
        >
            <div className="App">
                {sdk.locationPublic ? <PublicView sdk={sdk} /> : null}
                {sdk.locationEntity === 'auth' ? <AuthView sdk={sdk} /> : null}
                {sdk.locationEntity === 'employee' ? <EmployeeView sdk={sdk} /> : null}
                {sdk.locationEntity === 'manager' || sdk.locationEntity === 'admin' ? (
                    <PortalView sdk={sdk} />
                ) : null}
                {sdk.currentDialog ? <DialogView sdk={sdk} /> : null}
                <DialogInput />
                <Toast
                    ref={toast}
                    data-testid={'toast'}
                />
            </div>
        </PrimeReactProvider>
    );
});

export default App;
